import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";

import { LONG_DATE_TIME_FORMAT } from "../../../../../../utils/dateFormatter";
import { StyledTooltip } from "./CustomPromsRechartsTooltip.styles";

export function CustomPromsRechartsTooltip({
  active,
  payload,
}: TooltipProps<ValueType, NameType> | any) {
  const { t } = useTranslation();

  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const point = payload[0]?.payload;
  const isArchived = !!point?.archived;

  return (
    <StyledTooltip>
      <h4 style={{ marginBottom: 0 }}>
        <b>{t("patientPage_columns_date")}:</b>{" "}
        {dayjs(payload[0].value).format(LONG_DATE_TIME_FORMAT)}
      </h4>
      {isArchived && (
        <p
          style={{
            marginTop: 6,
            marginBottom: 0,
            opacity: 1,
          }}
        >
          {t("patientPage_proms_archivedMarker")}
        </p>
      )}
    </StyledTooltip>
  );
}
